import { useEffect, useState } from 'react'

export const usePrefersReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false)
  useEffect(() => {
    try {
      const matchMedia = window?.matchMedia
      if (matchMedia && typeof matchMedia === 'function') {
        const mediaQueryList = matchMedia('(prefers-reduced-motion: reduce)')
        setPrefersReducedMotion(Boolean(mediaQueryList?.matches))
      }
    } catch (error) {
      // Fallback to false if matchMedia is not supported or throws an error
      setPrefersReducedMotion(false)
    }
  }, [])
  return prefersReducedMotion
}
